'use client';

import classnames from 'classnames';
import dynamic from 'next/dynamic';
import { VideoEmbed as V3VideoEmbed } from '@stadionhq-v3/base-ui';
import styles from './videoEmbed.module.scss';
import { VideoEmbedProps } from './videoEmbed.types';

// The stream branch pulls in @stadionhq-v3/stream-ui and the ~824KB vesper
// SDK. Load it lazily (ssr: false) so none of that ships to article/news
// routes until a stream video embed actually renders in the browser.
const StreamVideoEmbed = dynamic(() => import('./streamVideoEmbed.component'), {
  ssr: false,
});

const VideoEmbed = ({
  dictionary,
  packagePageLinkPath,
  ...props
}: VideoEmbedProps) => {
  const classes = classnames([
    styles.videoEmbed,
    styles.videoEmbedTokens,
    props.theme?.themeId ? styles[props.theme.themeId] : styles.colourTheme1,
  ]);

  return (
    <>
      {props.video?.provider === 'stream' && props.video.id ? (
        <StreamVideoEmbed
          {...props}
          dictionary={dictionary}
          packagePageLinkPath={packagePageLinkPath}
          videoId={props.video.id}
          classes={classes}
        />
      ) : (
        <V3VideoEmbed {...props} classNames={[classes]} />
      )}
    </>
  );
};

export default VideoEmbed;
